import { Header, HeaderProps } from '@amzn/awsui-components-react';

interface TableHeaderProps extends HeaderProps {
    resourceName: string;
    totalItemCount: number;
    selectedItemsCount?: number;
}

function generateHeaderCountText(props: TableHeaderProps): string {
    if (props.selectedItemsCount && props.selectedItemsCount > 0) {
        return '(' + props.selectedItemsCount + '/' + props.totalItemCount + ')';
    }
    return '(' + props.totalItemCount + ')';
}

/**
 * This is a basic table header, with table title and selection count
 * @param props Include table name, total items count and selected items count
 * @returns Header
 */
function TableHeader(props: TableHeaderProps): JSX.Element {
    return (
        <Header
            counter={generateHeaderCountText(props)}
            info={props.info}
            description={props.description}
            actions={props.actions}
        >
            {props.resourceName}
        </Header>
    );
};

export default TableHeader;
